'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _MuiThemeProvider = require('material-ui/styles/MuiThemeProvider');

var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);

var _getMuiTheme = require('material-ui/styles/getMuiTheme');

var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);

var _colors = require('./colors.styles');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var charcoalGrey = _colors2.default.charcoalGrey,
    grey = _colors2.default.grey,
    offWhite = _colors2.default.offWhite,
    white = _colors2.default.white,
    orange = _colors2.default.orange;


var workMarketTheme = {
	fontFamily: 'Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif',
	palette: {
		canvasColor: white,
		primary1Color: orange,
		primary2Color: orange,
		accent1Color: orange,
		textColor: charcoalGrey
	},
	icon: {
		backgroundColor: grey,
		color: offWhite
	},
	spacing: {
		iconSize: 30
	},
	inkBar: {
		backgroundColor: white
	}
};

var WMThemeProvider = function (_Component) {
	_inherits(WMThemeProvider, _Component);

	function WMThemeProvider() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, WMThemeProvider);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WMThemeProvider.__proto__ || Object.getPrototypeOf(WMThemeProvider)).call.apply(_ref, [this].concat(args))), _this), _this.WMMuiTheme = (0, _getMuiTheme2.default)(workMarketTheme), _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(WMThemeProvider, [{
		key: 'render',
		value: function render() {
			return !this.context.muiTheme ? _react2.default.createElement(
				_MuiThemeProvider2.default,
				{ muiTheme: this.WMMuiTheme },
				this.props.children
			) : this.props.children;
		}
	}]);

	return WMThemeProvider;
}(_react.Component);

WMThemeProvider.contextTypes = {
	muiTheme: _propTypes2.default.object
};

exports.default = WMThemeProvider;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/common/WMThemeProvider/index.js